import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, map, includes, filter, concat, slice } from "lodash";
import clsx from "clsx";
import Grid from "@material-ui/core/Grid";

import RecurrenceEnds from "./RecurrenceEnds";
import RecurrenceEvery from "./RecurrenceEvery";
import { getRecurrenceSentence } from "../../../utils/scheduler";

const RecurrenceWeekly = (props) => {
  const { classes, formValues, changeParam } = props;
  return (
    <>
      <RecurrenceEvery
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <Grid item className={classes.row}>
        <Grid container alignItems="center">
          <Grid item className={classes.label} style={{ paddingBottom: 0 }}>
            {I18n.get("scheduler_on")}
          </Grid>
          <Grid item style={{ width: "220px" }}>
            <Grid container justify="space-between">
              {map(
                [
                  {
                    code: "sunday",
                    name: I18n.get("common_sunday"),
                  },
                  {
                    code: "monday",
                    name: I18n.get("common_monday"),
                  },
                  {
                    code: "tuesday",
                    name: I18n.get("common_tuesday"),
                  },
                  {
                    code: "wednesday",
                    name: I18n.get("common_wednesday"),
                  },
                  {
                    code: "thursday",
                    name: I18n.get("common_thursday"),
                  },
                  {
                    code: "friday",
                    name: I18n.get("common_friday"),
                  },
                  {
                    code: "saturday",
                    name: I18n.get("common_saturday"),
                  },
                ],
                (day) => (
                  <Grid
                    key={day.code}
                    className={clsx(classes.daySquare, {
                      [classes.daySquareActive]: includes(
                        get(formValues, ["recurrence", "on"]),
                        day.code
                      ),
                    })}
                    onClick={() =>
                      changeParam(
                        "on",
                        null,
                        includes(
                          get(formValues, ["recurrence", "on"]),
                          day.code
                        )
                          ? filter(
                              get(formValues, ["recurrence", "on"]),
                              (d) => d !== day.code
                            )
                          : concat(
                              [day.code],
                              get(formValues, ["recurrence", "on"]) || []
                            )
                      )
                    }
                  >
                    {slice(day.name, 0, 1)}
                  </Grid>
                )
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <RecurrenceEnds
        classes={classes}
        formValues={formValues}
        changeParam={changeParam}
      />
      <Grid item className="text-54" style={{ fontSize: "0.857em" }}>
        {getRecurrenceSentence("weekly", formValues)}
      </Grid>
    </>
  );
};

export default RecurrenceWeekly;
